import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import POIPageContent from '../components/POIPageContent';
import { getPOIById } from '../services/api';
import VerticalAdBanner from '../components/AdPlaceholder';
import Toast from '../components/Toast';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
  position: relative;
  max-width: 800px;
  margin: 80px auto 20px;
  padding: 0;
  width: 90%;
  height: 80vh;

  @media (max-width: 768px) {
    width: 95%;
    height: 90vh;
    margin-top: 60px;
    margin-bottom: 10px;
  }
`;

const MainContent = styled.div`
  flex: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const RightAdBanner = styled.div`
  position: fixed;
  top: 160px;
  right: 20px;
  z-index: 999;
  pointer-events: none;
  
  @media (max-width: 1200px) {
    display: none;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.2rem;
  color: #666;
  background: white;
  border-radius: 12px;
`;

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.2rem;
  color: #ff4444;
  text-align: center;
  padding: 20px;
  background: white;
  border-radius: 12px;
`;

const POIPage = () => {
  const { id } = useParams();
  const [poi, setPoi] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', type: '', link: null });

  const handleShowToast = (message, type = 'success', link = null) => {
    setToast({
      show: true,
      message,
      type,
      link
    });
  };

  const handleCloseToast = () => {
    setToast(prev => ({ ...prev, show: false }));
  };

  useEffect(() => {
    const fetchPOI = async () => {
      try {
        const data = await getPOIById(id);
        setPoi(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPOI();
  }, [id]);

  if (loading) {
    return (
      <PageContainer>
        <Navbar />
        <ContentContainer>
          <LoadingContainer>
            Loading...
          </LoadingContainer>
        </ContentContainer>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer>
        <Navbar />
        <ContentContainer>
          <ErrorContainer>
            Error: {error}
          </ErrorContainer>
        </ContentContainer>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Navbar />
      <ContentContainer>
        <MainContent>
          {poi && (
            <POIPageContent 
              poi={poi}
              onFavoriteRemoved={() => {
                // Handle favorite removal if needed
              }}
              onShowToast={handleShowToast}
            />
          )}
        </MainContent>
        <RightAdBanner>
          <VerticalAdBanner />
        </RightAdBanner>
      </ContentContainer>
      {toast.show && (
        <Toast 
          message={toast.message}
          type={toast.type}
          link={toast.link}
          onClose={handleCloseToast}
        />
      )}
    </PageContainer>
  );
};

export default POIPage;
